// extracted by mini-css-extract-plugin
export default {"recos":"r5-z","productCardOverride":"s5-z","rowHasBadge":"t5-z"};